import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  subscribeGlobalNetworkError,
  getGlobalNetworkError,
  clearGlobalNetworkError,
} from "utils/globalNetworkError";

/**
 * Subscribes to global network errors and shows a full-screen UI when one occurs.
 * Does not throw, so CRA's dev overlay won't appear.
 */
export default function NetworkErrorTrigger() {
  const { t } = useTranslation();
  const [error, setError] = useState(() => getGlobalNetworkError());

  useEffect(() => {
    return subscribeGlobalNetworkError(setError);
  }, []);

  const handleTryAgain = () => {
    clearGlobalNetworkError();
    window.location.reload();
  };

  if (!error) {
    return null;
  }

  return (
    <div
      className="flex flex-col items-center justify-center gap-4 p-6 text-center fixed inset-0 z-[9999] bg-surface"
      style={{ minHeight: "100vh", minWidth: "100vw" }}
      role="alert"
    >
      <h2 className="text-xl font-semibold text-text-body">
        {t("errorBoundary.networkError")}
      </h2>
      <p className="text-secondary max-w-md">
        {t("errorBoundary.networkErrorDesc")}
      </p>
      <button
        type="button"
        onClick={handleTryAgain}
        className="px-4 py-2 bg-primary text-surface rounded hover:brightness-90 focus:outline-none focus:ring-2 focus:ring-primary"
      >
        {t("errorBoundary.tryAgain")}
      </button>
    </div>
  );
}
